class FilterTabs extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this.clickHandler)
    this.addEventListener("keydown", this.keydownHandler)
  }

  disconnectedCallback() {
    console.log("[FT]", "disconnected")
    this.removeEventListener("click", this.clickHandler)
    this.removeEventListener("keydown", this.keydownHandler)
  }

  clickHandler = (evt) => {
    if (evt.target.matches('[role="tab"], [role="tab"] *')) {
      this.expand(evt.target.closest('[role="tab"]'))
    }
  }

  // based on https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/tab_role#example
  keydownHandler = (evt) => {
    const target = evt.target
    if (!target.matches('[role="tab"], [role="tab"] *')) return
    if (evt.key !== "ArrowRight" && evt.key !== "ArrowLeft") return

    const tabs = this.querySelectorAll('[role="tab"]')
    const current = [...tabs].indexOf(target)

    const selectedIndex = evt.key === "ArrowRight" ? current + 1 : current - 1
    const selected = tabs[selectedIndex]
    if (!selected) return

    target.setAttribute("tabindex", -1)
    selected.setAttribute("tabindex", 0)
    selected.focus()
    this.expand(selected)
  }

  expand(targetTab) {
    const controlsId = targetTab.getAttribute("aria-controls")
    const targetPanel = document.getElementById(controlsId)
    const targetExpanded = targetTab.getAttribute("aria-expanded") == "true"

    // check if already expanded
    if (targetExpanded) {
      targetTab.setAttribute("aria-expanded", false)
      targetPanel.setAttribute("hidden", true)
    } else {
      for (const tab of this.querySelectorAll('[role="tab"]')) {
        tab.setAttribute("aria-selected", tab === targetTab)
        tab.setAttribute("aria-expanded", tab === targetTab)
        tab.setAttribute("tabindex", tab === targetTab ? 0 : -1)
      }
      for (const panel of this.querySelectorAll('[role="tabpanel"]')) {
        panel.hidden = panel !== targetPanel
      }
      targetTab.focus()
    }
  }
}

customElements.define("filter-tabs", FilterTabs)
